// Plain helpers used by the resource dialogs and settings pages. Kept out of dialog-kit.tsx so that
// file only exports components (React fast refresh, AUTO-06).

export type ManagedImage = { imageUrl: string; sortOrder: number; isCover?: boolean };

export const slugify = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export function listItems<T>(value: unknown): T[] {
  if (Array.isArray(value)) return value as T[];
  if (value && typeof value === "object" && "data" in value && Array.isArray((value as { data?: unknown }).data)) return (value as { data: T[] }).data;
  return value ? [value as T] : [];
}

export function selectableOptions<T extends { id: string; isActive?: boolean }>(
  items: T[],
  selectedIds: string | string[] | undefined | null,
  isActive: (item: T) => boolean = (item) => item.isActive !== false,
): T[] {
  const selected = new Set(Array.isArray(selectedIds) ? selectedIds : selectedIds ? [selectedIds] : []);
  return items.filter((item) => isActive(item) || selected.has((item as { id: string }).id));
}

export function optionLabel(label: string, isActive?: boolean) {
  return isActive === false ? `${label} (inactive)` : label;
}

export function cleanBody<T extends Record<string, unknown>>(body: T, omit: string[] = []) {
  return Object.fromEntries(
    Object.entries(body).filter(([key, value]) => {
      if (omit.includes(key)) return false;
      if (value === "" || value === undefined || value === null) return false;
      if (typeof value === "number" && Number.isNaN(value)) return false;
      return true;
    }),
  );
}

export function normalizeCover<T extends ManagedImage>(images: T[], supportsCover = true): T[] {
  return images.map((image, index) => ({ ...image, sortOrder: index, isCover: supportsCover ? image.isCover || (!images.some((item) => item.isCover) && index === 0) : image.isCover }));
}
